module.exports = __webpack_public_path__ + "static/img/PB.6a11181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/PB.png
// module id = AVQ6
// module chunks = 1